import React from 'react';

import { FDContentContainer, FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';

const FDContentContainerLayout = ({ children, test }) => (
  <div test={test}>
    <FDContentContainer maxWidth="xl">
      <FDStack flexGrow={1} direction="column">
        {children}
      </FDStack>
    </FDContentContainer>
  </div>
);

FDContentContainerLayout.defaultProps = {
  test: '',
};
FDContentContainerLayout.propTypes = {
  children: PropTypes.node.isRequired,
  test: PropTypes.string,
};


function DefaultOrFDContentContainer(props) {
  return <FDContentContainerLayout {...props} />;
}

export default DefaultOrFDContentContainer;
